import React from 'react'
import '../../components/Graphs/graphStyles.scss'


export function DateTypeDropdown({ dateType, setDateType }) {

    const [open, setOpen] = React.useState(false);


    function handleToggleDropDown() {
        setOpen(!open)
    }

    function closeDropDownOnBlur(e) {
        if (open) {
            handleToggleDropDown()
        }
    }

    return (
        <div onBlur={() => closeDropDownOnBlur()}>
            <button className='dropdown__button__touch' onClick={handleToggleDropDown} >
                    {dateType}
                    {open ? (
                        <div className='dropdown__arrow__up'></div>
                    ) : (
                        <div className='dropdown__arrow__down'></div>
                    )}
            </button>

            {/* Dropdown arrow */}
            <div className={`dropdown__display__pointer dropdown__datetype__pointer ${open ? 'visible' : 'hidden'}`} style={{ zIndex: '5' }} />

            {/* <-- Drop down display --> */}
            <div className={`dropdown__display dropdown__display__touch date__type__dropdown ${open ? 'visible' : 'hidden'}`} style={{ zIndex: '4', marginTop: '6px', fontSize: '13.5px',  }}> 

                <button className='dropdown__item' onMouseDown={() => setDateType(0)}>Weekly</button>
                <button className='dropdown__item' onMouseDown={() => setDateType(1)}>Bi-Weekly</button>
                <button className='dropdown__item' onMouseDown={() => setDateType(2)}>Monthly</button>
                <button className='dropdown__item' onMouseDown={() => setDateType(3)}>Quarterly</button>
                <button className='dropdown__item' onMouseDown={() => setDateType(4)}>Half-Yearly</button>

            </div>
        </div>
    )
}